import { css } from "styled-components";
import { MarqueeWrapper, MarqueeContainer, MarqueeElement } from "../../components/Marquee";
import { headingTextFontMixin } from "../../../../skins/project-l/mixins/typography";
import { textUppercaseMixin } from "../../../../skins/shared/mixins/typography";
export const riotProductSkin = (chroma, paletteTokens) => css `
  & {
    position: relative;
    max-width: ${chroma.dimensions.pageWidth};
    width: 100%;
    margin: 0 auto;
    background-color: ${paletteTokens.bladebg1};
  }

  ${MarqueeContainer} {
    overflow: hidden;
    display: flex;
    padding: 10px 0;
    ${headingTextFontMixin}

    &.bottom-banner {
      background-color: ${paletteTokens.bladebg3};
      ${chroma.mediaQueries.tabletDown} {
        padding: 0;
      }
      & ${MarqueeElement} span {
        color: ${paletteTokens.bladetext3};
        font-size: 30px;
        font-weight: bold;
        line-height: 35.67px;

        ${chroma.mediaQueries.tabletDown} {
          font-size: 16px;
        }
      }
    }

    ${MarqueeWrapper} {
      display: flex;
      flex-direction: row;
      white-space: nowrap;
    }

    ${MarqueeElement} {
      display: flex;
      align-items: center;
      will-change: transform;

      ${textUppercaseMixin}
      & > span {
        display: inline;
        padding: 0 5px;
        font-size: 73px;
        white-space: nowrap;
        margin: 0;
        font-weight: 700;
        color: ${paletteTokens.bladetext1};

        ${chroma.mediaQueries.tabletDown} {
          font-size: 39px;
          line-height: 32px;
        }

        &.undecorated {
          min-width: 100px;
          ${chroma.mediaQueries.tabletDown} {
            min-width: 50px;
          }
        }

        &.decorated {
          margin-top: 2px;
          display: flex;
          align-items: center;
          position: relative;
          height: 55px;
          line-height: 55px;
          ${chroma.mediaQueries.tabletDown} {
            height: 32px;
            line-height: 32px;
          }

          & .main {
            padding: 0 26px 0 25px;
            color: ${paletteTokens.bladebg1};
            font-size: 30px;
            background-color: ${paletteTokens.bladetext1};
            ${chroma.mediaQueries.tabletDown} {
              font-size: 22px;
            }
          }

          & .accent {
            height: 55px;
            margin-left: -1px;
            ${chroma.mediaQueries.tabletDown} {
              height: 32px;
            }

            & span {
              height: 100%;
              max-width: unset;
            }
          }
        }
      }

      & .decoration {
        display: inline-block;
        height: 20px;
        width: 200px;
        background: repeating-linear-gradient(
          45deg,
          ${paletteTokens.bladetext3},
          ${paletteTokens.bladetext3} 5px,
          transparent 5px,
          transparent 10px
        );
        ${chroma.mediaQueries.tabletDown} {
          height: 16px;
        }
      }
    }

    /* JP local overrides */
    &:lang(ja-jp) {
      ${MarqueeElement} {
        & > span {
          font-weight: 900;
        }
      }
    }

    /* KR locale overrides */
    &:lang(ko-kr) {
      ${MarqueeElement} {
        & > span {
          font-weight: 400;

          &.undecorated {
            position: relative;
            bottom: -7px;
          }

          &.decorated .main {
            padding: 15px 26px 0 25px;
            height: 55px;
            line-height: 1;
            ${chroma.mediaQueries.tabletDown} {
              height: 32px;
              padding: 8px 26px 0 25px;
            }
          }
        }
      }

      &.bottom-banner ${MarqueeElement} span {
        display: block;
        position: relative;
        bottom: -2px;
        font-size: 27px;
      }
    }
  }
`;
//# sourceMappingURL=index.js.map